const MuiDateRangeCalendar = {
    defaultProps: {
        dayOfWeekFormatter: (day)=>day.slice(0, 2),
        showDaysOutsideCurrentMonth: true,
        calendars: 1
    },
    styleOverrides: {
        root: {
            ['.MuiPickersSlideTransition-root']: {
                minHeight: '200px'
            }
        }
    }
};
export { MuiDateRangeCalendar };

//# sourceMappingURL=date-range-calendar-overrides.js.map